<script setup lang="ts">
import { computed, toRef } from 'vue'
import ResourceCard from '@/resources/ResourceCard.vue'
import ResourceTile from '@/resources/ResourceTile.vue'
import { getAnalyticsTracker } from '@/tracking/analytics/plugin'
import type { AnalyticsData } from '@/tracking/analytics/analyticsTracker'
import type { Resource } from '@/resources/resource_types'
import { liveEventData } from '@/resources/live_event_data'

const props = withDefaults(
  defineProps<{
    resources: Resource[]
    selectedLanguage: string
    isTiled?: boolean
    evtData?: AnalyticsData
    headingLevel?: number
  }>(),
  {
    isTiled: false,
    evtData: () => ({}),
    headingLevel: 4
  }
)

getAnalyticsTracker().getChildContext({
  selected_language: toRef(props, 'selectedLanguage'),
  ...liveEventData(() => props.evtData)
})

const listClass = computed(() => (props.isTiled ? 'flex flex-wrap' : ''))
</script>

<template>
  <div :class="listClass" role="list" data-testid="multilingual-resources">
    <template v-if="isTiled">
      <ResourceTile v-for="resource in resources" :key="resource.uuid" role="listitem" :resource="resource" aria-live="polite" />
    </template>
    <template v-else>
      <ResourceCard
        v-for="resource in resources"
        :key="resource.uuid"
        v-bind="resource"
        :heading-level="headingLevel"
        role="listitem"
        aria-live="polite"
      />
    </template>
    <slot />
  </div>
</template>
